import $ from 'jquery';

const block = async (status = true) => {
  if (status) {
    window.hasActiveOperation = true;
  }

  $('.preloader').show().css('opacity', '.7');
};

const unblock = async (status = true) => {
  if (status) {
    window.hasActiveOperation = false;
  }
  $('.preloader').hide();
};

// eslint-disable-next-line object-curly-newline
export {
  block,
  unblock,
};
